import { useEffect, useState } from "react";
import { getServiceHistoryByDates } from "../../request/service-history";
import { BodyContainer, Main, StyledLabel, StyledText } from "../../components/styled/styled";
import './service-history.css';
// import { IServiceHistoryList } from '../../interfaces/service-history';
import CardHistorial from "./cards/card-historial/card-historial";
// import orderComandasHistorial from '../../utils/orderComandasHistorial';
import Loader from "../../components/elements/loader/loader";
import { showPopup } from "../../utils/showAlert";
// import { getDay } from "../../utils/getDay";
import { soft_gray } from "../../components/styled/constant";
import styled from "styled-components";
import ModalDatePicker from "./modal/modalDatePicker";

import calendar from '../../assets/icon-calendar.svg';
import { BsCalendarRange } from 'react-icons/bs';
import ModalDateRangePicker from "./modal/modalDateRangePicker";

// Polling reemplazó Socket.IO el 2026-05-19
const POLLING_INTERVAL_MS = 20000;

export default function ServiceHistory() {
    // const [historialData, setHistorialData] = useState<IServiceHistory>({
    //     totalServicios: 0,
    //     totalProductos: 0,
    //     cantidadServicios: 0,
    //     cantidadProductos: 0,
    //     detalle: []
    // });
    const [historial, setHistorial] = useState<any>();
    const today = new Date();
    const [filteredComandasNoPagadas, setFilteredComandasNoPagadas] = useState<any>();
    const [filteredComandasPagadas, setFilteredComandasPagadas] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalRange, setShowModalRange] = useState(false);
    const [startDate, setStartDate] = useState(today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2));
    // const [endDate, setEndDate] = useState(today.getFullYear() + '-' + ('0' + (today.getMonth() + 1)).slice(-2) + '-' + ('0' + today.getDate()).slice(-2));

    useEffect(() => {
        loadData(false);
    }, [startDate]); //eslint-disable-line

    async function loadData(refresh:boolean) {
        if(refresh === false) {setIsLoading(true);}
        try {
            // let data = await getServiceHistory();
            let data = await getServiceHistoryByDates(startDate, startDate);
            // setHistorialData(data);
            setHistorial(data);
            // let handler = orderComandasHistorial(data.detalle);
            // let comandasPagadas = handler.filter(x => x.cobrada === 1);
            // let comandasNoPagadas = handler.filter(x => x.cobrada === 0);
            setFilteredComandasPagadas(data.comandaPagada);
            setFilteredComandasNoPagadas(data.comandaPendientePago);

        } catch (error: any) {
            // Solo mostramos el popup en la carga inicial; los refreshes silenciosos
            // del polling no deben spammear modales si el endpoint falla
            // (caso SOHO Schell 2026-05-20).
            if (refresh === false) {
                showPopup({
                    title: "No pudimos cargar tu historial",
                    message: error?.message || "Verifica tu conexión a internet e intenta de nuevo.",
                    icon: 'error',
                })
            } else {
                console.warn('[historial] polling falló silenciosamente:', error?.message);
            }
        }
        finally {
            setIsLoading(false);
        }
    }

    // Polling cada 20s reemplaza socket events.
    // Si la última carga falló no seguimos pollando (evita spam de errores en backend).
    useEffect (()=>{
        const interval = setInterval(() => {
            loadData(true);
        }, POLLING_INTERVAL_MS);
        return () => clearInterval(interval);
    },[startDate]) //eslint-disable-line

  
    return (
        <>
            <ModalDatePicker show={showModal} setShowModal={setShowModal} fadeOut={false} setStartDate={setStartDate}/>
            <ModalDateRangePicker show={showModalRange} setShowModal={setShowModalRange} fadeOut={false}/>
            <BodyContainer>
                <Main>
                    {
                        isLoading ? <Loader /> :
                            <>
                                <span style={{fontSize: '16px'}}>Selecciona la fecha que quieres consultar</span><br/>
                                <div style={{display: 'flex', alignItems: 'center', margin: '10px 0 0 0'}}>
                                    <img src={calendar} alt='fecha' style={{height: '14px', marginRight: '10px'}}/>
                                    <StyledLabel
                                        color='purple_1'
                                        style={{margin: '0 16px 0 0', width: 'auto', position: 'relative', whiteSpace: 'nowrap'}}
                                    >
                                        <Input
                                            type='date'
                                            style={{
                                                color: 'black'
                                            }}
                                            value={startDate}
                                            onChange={e => setStartDate(e.target.value)}
                                        />
                                        <span style={{color: '#937CF4', whiteSpace: 'nowrap'}}>
                                            {new Date(startDate + 'T00:00:00-05:00').toLocaleDateString('es-ES', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
                                        </span>
                                    </StyledLabel>
                                    <BsCalendarRange size={22} color="#937CF4" style={{cursor: 'pointer'}} onClick={() => setShowModalRange(true)} title="Filtrar por rango de fechas"/>
                                </div>
                                <div className="containerHistorial">
                                    <div className="containerCantidades">
                                        <div
                                            style={{ margin: "0px 10px 0px 0px" }} className="cardEstadistica">
                                            <p className="textoEstadistica">{historial?.cantidadServicios}</p>
                                            <p className="textoDetalle">
                                                Total de servicios
                                            </p>

                                        </div>
                                        <div
                                            style={{ margin: "0px 0px 0px 0px" }} className="cardEstadistica">
                                            <p className="textoEstadistica">{historial?.cantidadProductos}</p>
                                            <p className="textoDetalle">
                                                Total de productos
                                            </p>

                                        </div>
                                    </div>
                                    <div className="containerTotales">
                                        <div
                                            style={{ margin: "0px 10px 0px 0px" }} className="cardEstadistica">
                                            <p className="textoEstadistica">S/.{historial?.totalServicios}</p>
                                            <p className="textoDetalle">
                                                Total por servicios
                                            </p>

                                        </div>
                                        <div
                                            style={{ margin: "0px 0px 0px 0px" }} className="cardEstadistica">
                                            <p className="textoEstadistica">S/.{historial?.totalProductos}</p>
                                            <p className="textoDetalle">
                                                Total por productos
                                            </p>
                                        </div>
                                    </div>
                                    <p style={{fontSize: '14px', color: '#727070'}}>*Los totales se calculan incluyendo ventas cobradas sin pasar por comandas.</p>
                                </div>
                                <StyledLabel>Comandas pendientes de pago</StyledLabel>
                                <StyledText>Aquí se muestran las comandas que aún no han sido cobradas</StyledText>
                                {filteredComandasNoPagadas?.length ? filteredComandasNoPagadas?.map((item: any, index: number) => {
                                    return <CardHistorial key={index} myKey={index} data={item} />
                                }) : <GrayDiv>
                                    <StyledText>No hay comandas registradas</StyledText>
                                </GrayDiv>
                                }

                                <StyledLabel>Comandas pagadas</StyledLabel>
                                <StyledText>Aquí aparecerán las comandas que han sido pagadas</StyledText>
                                {filteredComandasPagadas?.length ? filteredComandasPagadas?.map((item: any, index: number) => {
                                    return <CardHistorial key={index} myKey={index} data={item} noEditable={true} />
                                }) :
                                    <GrayDiv>
                                        <StyledText>No hay comandas registradas</StyledText>
                                    </GrayDiv>
                                }

                                <StyledLabel>Ventas directas</StyledLabel>
                                <StyledText>Servicios cobrados desde caja sin pasar por una comanda</StyledText>
                                {historial?.ventasDirectas?.length ? historial.ventasDirectas.map((item: any, index: number) => {
                                    return <CardHistorial key={`vd-${index}`} myKey={index} data={item} noEditable={true} />
                                }) :
                                    <GrayDiv>
                                        <StyledText>No hay ventas directas registradas</StyledText>
                                    </GrayDiv>
                                }
                            </>}
                    <div style={{ height: '1rem' }}></div>
                </Main>
            </BodyContainer>
        </>
    );
}

const GrayDiv = styled.div`
background-color: ${soft_gray};
width: 100%;
height: 10rem;
display: flex;
justify-content: center;
align-items: center;
text-align: center;
border-radius: 10px;
margin: 1rem 0;
`;

const Input = styled.input`
    position: absolute;
    margin-left: -10px;
    margin-top: -10px;
    opacity: 0;
    &::-webkit-calendar-picker-indicator {
        padding-left: 200px;
        margin-left: -130px;
    }
`;